import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const layoutPreviewBlockStyles = {
  backgroundColor: '#022b3a',
  borderRadius: 0.5,
};

const layoutTooltipContent = (
  <Stack spacing={1.25} sx={{ maxWidth: 380, py: 0.5 }}>
    <Typography variant="subtitle2" sx={{ color: 'common.white', fontWeight: 700 }}>
      Layout Styles
    </Typography>
    <Stack direction="row" spacing={1.5} alignItems="flex-start">
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 0.5,
            p: 0.75,
            border: '1px solid rgba(255, 255, 255, 0.24)',
            borderRadius: 1,
          }}
        >
          <Box sx={{ ...layoutPreviewBlockStyles, height: 10 }} />
          <Box sx={{ ...layoutPreviewBlockStyles, height: 18 }} />
          <Box sx={{ ...layoutPreviewBlockStyles, height: 13 }} />
          <Box sx={{ ...layoutPreviewBlockStyles, height: 16 }} />
        </Box>
        <Typography variant="caption" sx={{ color: 'grey.200', mt: 0.5, display: 'block' }}>
          Grid: Cards are aligned on a uniform grid with consistent row heights
        </Typography>
      </Box>
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            display: 'flex',
            gap: 0.75,
            p: 0.75,
            border: '1px solid rgba(255, 255, 255, 0.24)',
            borderRadius: 1,
          }}
        >
          <Stack spacing={0.5} sx={{ flex: 1 }}>
            <Box sx={{ ...layoutPreviewBlockStyles, height: 10 }} />
            <Box sx={{ ...layoutPreviewBlockStyles, height: 18 }} />
            <Box sx={{ ...layoutPreviewBlockStyles, height: 13 }} />
          </Stack>
          <Stack spacing={0.5} sx={{ flex: 1 }}>
            <Box sx={{ ...layoutPreviewBlockStyles, height: 16 }} />
            <Box sx={{ ...layoutPreviewBlockStyles, height: 9 }} />
            <Box sx={{ ...layoutPreviewBlockStyles, height: 20 }} />
          </Stack>
        </Box>
        <Typography variant="caption" sx={{ color: 'grey.200', mt: 0.5, display: 'block' }}>
          Lanes: Cards are organized into lanes with independent spacing, allowing for a more
          free-form layout
        </Typography>
      </Box>
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 0.5,
            p: 0.75,
            border: '1px solid rgba(255, 255, 255, 0.24)',
            borderRadius: 1,
          }}
        >
          {[0, 1, 2].map((columnIndex) => (
            <Stack key={columnIndex} spacing={0.5}>
              <Box sx={{ ...layoutPreviewBlockStyles, height: 10 }} />
              <Box sx={{ ...layoutPreviewBlockStyles, height: 16 }} />
            </Stack>
          ))}
        </Box>
        <Typography variant="caption" sx={{ color: 'grey.200', mt: 0.5, display: 'block' }}>
          Columns: Cards are grouped into named columns for retrospectives and workflows
        </Typography>
      </Box>
    </Stack>
  </Stack>
);

const BoardLayoutTooltip = () => (
  <Tooltip title={layoutTooltipContent} arrow placement="right">
    <IconButton size="small" aria-label="Show layout style examples">
      <InfoOutlinedIcon sx={{ fontSize: 18 }} />
    </IconButton>
  </Tooltip>
);

export default BoardLayoutTooltip;
